<template>
  <div>
    <v-card dark color="#191a1a" flat rounded="0">
      <v-card-text class="info-container" :style="style">
        <div>
          <Loader
            v-if="loading"
            color="white"
            :text="loaderText"
            size="small"
            class="loader"
          ></Loader>
          <v-btn
            v-if="!loading && info"
            class="mr-2 mb-2 pull-right"
            outlined
            small
            v-on:click="copyScribeToClipboard = new Date().toISOString()"
          >
            <v-icon class="mr-2 left" size="15" :title="copyText"
              >far fa-clipboard</v-icon
            >
            Copy
          </v-btn>
          <div class="clearfix"></div>
          <ScribeInfo
            v-if="!loading && info"
            :info="info"
            :copy-scribe-to-clipboard="copyScribeToClipboard"
            :location-name="locationName"
          ></ScribeInfo>
          <div v-if="!loading && !info">
            No {{ labels.scribe }} information found
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import lodashDebounce from "lodash/debounce";
import lodashIsEqual from "lodash/isEqual";

import { getScribeInfo } from "@/services/scribe/scribe.service";
import { getTodayStartEndDate } from "@/common/date.utilities";
import { LABELS } from "@/common/constants/labels";

export default {
  name: "ScribeLayout",
  components: {
    ScribeInfo: () => import("@/components/scribe/ScribeInfo"),
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    score: {
      type: [String, Number],
    },
    height: {
      type: Number,
    },
    dateSelected: {
      type: String,
    },
  },
  data() {
    return {
      info: null,
      loading: false,
      copyScribeToClipboard: null,
      labels: LABELS,
    };
  },
  mounted() {
    if (!this.isHistoricalDate) {
      this.getScribeInfo();
    }
  },
  computed: {
    style() {
      return {
        height: `${this.height}px`,
      };
    },
    isHistoricalDate() {
      const TODAY = getTodayStartEndDate();
      return this.dateSelected !== TODAY.end;
    },
    locationName() {
      return this.location && this.location.type === "region"
        ? this.location.name
        : null;
    },
    loaderText() {
      return `${this.labels.scribe} is writing your report`;
    },
    copyText() {
      return `Copy ${this.labels.scribe} to Clipboard`;
    },
  },
  methods: {
    async getScribeInfo() {
      this.loading = true;
      lodashDebounce(async () => {
        if (this.location && this.location.code && this.location.type) {
          let result = await getScribeInfo({
            locationCode: this.location.code,
            locationType: this.location.type,
            date: this.isHistoricalDate ? this.dateSelected : null,
            score: this.score,
          });
          if (
            result &&
            lodashIsEqual(
              {
                locationCode: this.location.code,
                locationType: this.location.type,
                date: this.isHistoricalDate ? this.dateSelected : null,
                score: this.score,
              },
              result.params
            )
          ) {
            this.info = result.data;
          }
        }
        this.loading = false;
      }, 1000)();
    },
  },
  watch: {
    location: {
      handler() {
        this.getScribeInfo();
      },
      deep: true,
    },
    score() {
      this.getScribeInfo();
    },
    dateSelected(oldVal, newVal) {
      if (oldVal !== newVal) {
        this.getScribeInfo();
      }
    },
  },
  beforeDestroy() {
    this.info = null;
  },
};
</script>

<style>
.loader .loading-text {
  position: relative;
  top: 2px;
}
</style>

<style scoped>
.info-container {
  overflow-y: auto;
  color: white !important;
}
/* These are for the scroll bar in the content container */
::-webkit-scrollbar {
  width: 8px;
  height: 3px;
}
::-webkit-scrollbar-track {
  background-color: #646464;
  border-radius: 3px;
}
::-webkit-scrollbar-track-piece {
  background-color: #000;
}
::-webkit-scrollbar-thumb {
  height: 50px;
  background-color: #666;
  border-radius: 3px;
}
</style>
